/** @format */

import React, { MouseEventHandler, ReactNode } from "react";
import styled from "styled-components";
import { colors } from "../../../css/variables/colors";

const ButtonStyle = styled.button`
  background: transparent;
  border-radius: 4px;
  padding: 0;
  border: none;
  color: ${colors.themeColor("text_link")};
  cursor: pointer;
  &:hover,
  &:active {
    text-decoration: underline;
  }
`;

const TextButton = ({ onClick, children }: { onClick: MouseEventHandler<HTMLElement>; children: ReactNode }) => {
  return <ButtonStyle onClick={onClick}>{children}</ButtonStyle>;
};

export default TextButton;
